/**
 * "You're going" marker for event cards — top-right so it can coexist with
 * the category tag (top-left) and the price badge (bottom-right).
 * Render it inside a relatively-positioned card image container, gated on
 * useMyEventIds().has(eventId).
 */
export function AttendingBadge() {
  return (
    <span className="absolute right-2 top-2 z-10 rounded-full bg-emerald-500/90 px-2 py-0.5 text-[9px] font-semibold text-white shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
      You&apos;re going
    </span>
  );
}
